import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCommonModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { fuseAnimations } from 'src/@fuse/animations';
import { FuseConfigService } from 'src/@fuse/services/config.service';
import { FuseSharedModule } from 'src/@fuse/shared.module';
import { confirmPasswordValidator } from 'src/app/shared';

import { LoadingComponent } from '../../generals/loading/loading.component';
import { PinCodeConfig } from '../../generals/pin-code/pin-code-config';
import { PinCodeComponent } from '../../generals/pin-code/pin-code.component';
import { AppManageService } from '../../services/app-manage.service';
import { MicroResponse } from '../../services/microservices/response/micro.response';
import { SimpleResponse } from '../../services/microservices/response/simple.response';
import { UserService } from '../../services/user.service';
import { SessionService } from '../../services/user/session/session.service';
import { ForgotStep } from './forgot-step.enum';
import { NumberBoardComponent } from '../../generals/number-board/number-board.component';
import { WellcomeComponent } from '../../generals/wellcome/wellcome.component';

@Component({
  selector: 'app-forgot-password-finish',
  templateUrl: './forgot-password-finish.component.html',
  styleUrls: ['./forgot-password-finish.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatCommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSnackBarModule,
    MatMomentDateModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    FlexLayoutModule,
    FuseSharedModule,
    PinCodeComponent,
    LoadingComponent,
    NumberBoardComponent,
    WellcomeComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class ForgotPasswordFinishComponent implements OnInit {
  key!: string;
  boardPinCode = '';
  stateProcess!: string;
  step: number = ForgotStep.registerNewPassword;
  pinCodeConfig: PinCodeConfig = { isPinCodeBoard: true };
  forgotPasswordForm!: FormGroup;
  forgStep: typeof ForgotStep = ForgotStep;
  @ViewChild(PinCodeComponent) pinCodeComp!: PinCodeComponent;
  isForm!: boolean;
  showPassword!: boolean;
  showPasswordConfirm!: boolean;
  showNextButton = false;
  isProcessOk = false;
  isProcessError = false;
  loading = false;

  constructor(
    private _route: ActivatedRoute,
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private _userService: UserService,
    private _activatedRoute: ActivatedRoute,
    private _redirectRoute: Router,
    private _snackBar: MatSnackBar,
    private _sessionService: SessionService,
    private _appManageService: AppManageService,
  ) {
    this.forgotPasswordForm = this._formBuilder.group({
      newPassword: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^(?:(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).*)$',
          ),
        ],
      ],
      passwordConfirm: [
        '',
        [
          Validators.required,
          confirmPasswordValidator('newPassword', 'passwordConfirm'),
        ],
      ],
      pinCode: ['', [Validators.required, Validators.minLength(6)]],
    });
    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: { hidden: true },
        toolbar: { hidden: true },
        footer: { hidden: true },
        sidepanel: { hidden: true },
      },
    };
    this.isForm = true;
  }

  ngOnInit(): void {
    const url = window.location.href;
    this._appManageService.detectarDispositivo(url);

    this._route.queryParamMap.subscribe((query: any) => {
      if (Object.keys(query.params).length) {
        localStorage.setItem(
          'idRestorePasswordComplete',
          JSON.stringify(query.params),
        );
      }
    });
    this.verifyIdEncripted();
  }

  checkPassword(): void {
    this.showPassword = !this.showPassword;
  }

  checkPasswordConfirm(): void {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }

  processPin(pinCode: string) {
    this.forgotPasswordForm.patchValue({ pinCode: pinCode });
  }

  next(event: any): void {
    event.preventDefault();
    switch (this.step) {
      case this.forgStep.registerNewPassword: {
        if (this.formValidStep()) {
          this.showNextButton = false;
          this.step++;
          break;
        }
      }
    }
  }

  formValidStep(): boolean {
    return (
      this.forgotPasswordForm.get('newPassword')?.status === 'VALID' &&
      this.forgotPasswordForm.get('passwordConfirm')?.status === 'VALID'
    );
  }

  verifyIdEncripted() {
    this.loading = true;
    const valueStorage: string | any = localStorage.getItem(
      'idRestorePasswordComplete',
    );
    const value = JSON.parse(valueStorage);
    this._userService.checkUserProcess(value.Id).subscribe((response: any) => {
      switch (response.data.id) {
        case 1:
          this.isProcessOk = true;
          break;
        case 2:
          this.isProcessError = true;
          this.stateProcess =
            'este acceso ya fue utilizado o no existe, solicita un nuevo cambio de credenciales';
          break;
        case 3:
          this.isProcessError = true;
          this.stateProcess =
            'el tiempo de uso a expirado, solicita un nuevo cambio de credenciales';
          break;
      }
      this.loading = false;
    });
  }

  verifyNewPassword() {
    this.loading = true;
    const password = this.forgotPasswordForm.get('newPassword')?.value;
    const valueStorage: string | any = localStorage.getItem(
      'idRestorePasswordComplete',
    );
    const value = JSON.parse(valueStorage);
    this._userService.verifyPassword(value.Id, password).subscribe({
      next: (response: MicroResponse<SimpleResponse>) => {
        if (response.data.id === 1) {
          this.step = this.forgStep.registerNewPin;
        } else if (response.data.id === 5) {
          this._snackBar.open(
            'Password utilizado anteriormente, inténtalo de nuevo',
            undefined,
            {
              verticalPosition: 'top',
              horizontalPosition: 'right',
              panelClass: ['snack-info'],
              duration: 3000,
            },
          );
        } else {
          this._snackBar.open('Ocurrió algo', undefined, {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snack-info'],
            duration: 3000,
          });
        }
        this.loading = false;
      },
      error: (error: any) => {
        if (error.status === 400) {
          console.error('Error al verificar Password');
        }
      },
    });
  }

  verifyNewPin() {
    this.loading = true;
    const pin = this.forgotPasswordForm.get('pinCode')?.value;
    const valueStorage: string | any = localStorage.getItem(
      'idRestorePasswordComplete',
    );
    const value = JSON.parse(valueStorage);
    this._userService.verifyPin(value.Id, pin).subscribe({
      next: (response: MicroResponse<SimpleResponse>) => {
        if (response.data.id === 1) {
          this.onSubmit();
        } else {
          if (response.data.id === 5) {
            this._snackBar.open(
              'Pin utilizado anteriormente, inténtalo de nuevo',
              undefined,
              {
                verticalPosition: 'top',
                horizontalPosition: 'right',
                panelClass: ['snack-info'],
                duration: 3000,
              },
            );
          } else {
            this._snackBar.open('Ocurrió algo', undefined, {
              verticalPosition: 'top',
              horizontalPosition: 'right',
              panelClass: ['snack-info'],
              duration: 3000,
            });
          }
          this.pinCodeComp.resetComponent();
          this.resetPinValue();
        }
        this.loading = false;
      },
      error: (error: any) => {
        if (error.status === 400) {
          console.error('Error al verificar Pin');
        }
      },
    });
  }

  onSubmit() {
    const password = this.forgotPasswordForm.get('newPassword')?.value;
    const pin = this.forgotPasswordForm.get('pinCode')?.value;
    const valueStorage: string | any = localStorage.getItem(
      'idRestorePasswordComplete',
    );
    const jsonStorage = JSON.parse(valueStorage);
    const idProcess = jsonStorage.Id;
    this._userService.updatePasswordPin(idProcess, password, pin).subscribe({
      next: () => {
        this.isForm = false;
        localStorage.removeItem('idRestorePasswordComplete');
        sessionStorage.removeItem('dataLoginUser');
      },
    });
  }

  receiveValue(value: string) {
    if (value.toString().match('Atras')) {
      this.boardPinCode = '';
      this.forgotPasswordForm.patchValue({ pinCode: this.boardPinCode });
      this.step--;
      return;
    }
    if (value.toString().match('Borrar')) {
      this.boardPinCode = this.boardPinCode.slice(0, -1);
      value = '';
    }
    if (this.boardPinCode.length === 6) {
      value = '';
    }
    this.boardPinCode += value;
    this.forgotPasswordForm.patchValue({ pinCode: this.boardPinCode });
  }

  resetPinValue(): void {
    this.boardPinCode = '';
    this.forgotPasswordForm.patchValue({ pinCode: '' });
  }

  hasPasswordError(): boolean | undefined {
    const passwordControl = this.forgotPasswordForm.get('newPassword');
    return (
      passwordControl?.invalid &&
      (passwordControl?.touched || passwordControl?.dirty)
    );
  }

  hasPasswordConfirmError(): boolean | undefined {
    const passwordConfirmControl =
      this.forgotPasswordForm.get('passwordConfirm');
    return (
      passwordConfirmControl?.invalid &&
      (passwordConfirmControl?.touched || passwordConfirmControl?.dirty)
    );
  }

  getPasswordErrorTooltip(): string {
    const passwordControl = this.forgotPasswordForm.get('newPassword');
    if (passwordControl?.hasError('required')) {
      return 'La contraseña es requerida';
    } else if (passwordControl?.hasError('pattern')) {
      return 'La contraseña debe contener entre 8 y 16 caracteres y tener por lo menos 1 Mayúscula, 1 Minúscula, 1 Numero, 1 carácter especial (@$%¡*¿)';
    } else if (passwordControl?.hasError('enterAnotherPassword')) {
      return '';
    }
    return '';
  }

  getPasswordConfirmErrorTooltip(): string {
    const passwordConfirmControl =
      this.forgotPasswordForm.get('passwordConfirm');
    if (passwordConfirmControl?.hasError('required')) {
      return 'La confirmacion de Contraseña es requerido';
    } else if (
      !passwordConfirmControl?.hasError('required') &&
      passwordConfirmControl?.hasError('passwordsNotMatching')
    ) {
      return 'Contraseñas no coinciden';
    } else if (passwordConfirmControl?.hasError('enterAnotherPassword')) {
      return 'Ingrese otra contraseña';
    }
    return '';
  }
}
